import api from '@pray/shared/utils/api';

export async function createContentSeries({
  artistId = '',
  title = '',
  description = '',
  imageUrl = null,
  portraitImageUrl = null,
  landscapeImageUrl = null,
  isVisible = true,
  contentOrder = 'default',
  externalUrl = undefined,
  displayDate = false,
  sourceLocaleCode = undefined,
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!title) throw Error('Title is required');
  if (!description) throw Error('Description is required');
  if (isVisible && !imageUrl) throw Error('Image URL is required for public content series');

  const data = {
    title,
    description,
    is_visible: isVisible,
    content_order: contentOrder,
    display_date: displayDate,
  };

  if (imageUrl) data.image_url = imageUrl;
  if (portraitImageUrl) data.portrait_image_url = portraitImageUrl;
  if (landscapeImageUrl) data.landscape_image_url = landscapeImageUrl;

  // External URLs must have a valid link or be null to be created
  data.external_url = externalUrl || null;

  // Source language picked at creation (undefined when untouched → omitted; the server defaults to
  // English). A series' source is the default inherited by episodes added to it later.
  if (sourceLocaleCode !== undefined) data.source_locale_code = sourceLocaleCode;

  const url = `/web/studio/artists/${artistId}/content-series`;
  const response = await api.executePostRequest(url, data);

  return response.data.data;
}
